import { render } from "./DashboardConfigurationCard.vue?vue&type=template&id=bc12f27e&ts=true"
import script from "./DashboardConfigurationCard.vue?vue&type=script&lang=ts"
export * from "./DashboardConfigurationCard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__